export const RECEIVE_THANK_YOU_DATA = 'tyPage/RECEIVE_THANK_YOU_DATA';
export const SET_THANK_YOU_ERROR = 'tyPage/SET_THANK_YOU_ERROR';
export const SET_NPS_SCORE = 'tyPage/SET_NPS_SCORE';
export const SET_NPS_STATUS = 'tyPage/SET_NPS_STATUS';
export const UPDATE_NPS_FORM_DATA = 'tyPage/UPDATE_NPS_FORM_DATA';
export const RESET_NPS = 'tyPage/RESET_NPS';
export const SET_NPS_DATA = 'tyPage/SET_NPS_DATA';
